import { RootState } from 'editor/src/store/index';

const getPreviewStatus = (state: RootState) => state.editorModules.preview.status;

export default getPreviewStatus;
